import React from 'react';

const ClockIcon = () => {
      return (
            <>
                  <span className="material-symbols-outlined">schedule</span>
            </>
      );
};

export default ClockIcon;
